export const SERVER_DATE_TIME_FORMAT = 'yyyy-MM-ddTHH:mm';



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/date-time.constants.ts